import { createFileRoute } from '@tanstack/react-router';
import NoOrgPage from 'src/features/plugins/outlook/(auth)/(setup)/no-org/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/no-org')({
  component: NoOrgPage,
});
